<div  [ngClass]="{'isWelcome': isWelcome ,'displayForm': isFormShow, 'hiddenForm': !isFormShow}">
  <div class="ftdCard" #addFundFormElement>
    <form [formGroup]="addFundForm" (ngSubmit)="onSubmit()" [ngClass]="{'displayForm': isFormShow, 'hiddenForm': !isFormShow ,'ftdCardForm' : !isWelcome}" >
      <h3 *ngIf="isWelcome" class="add-card">ADD CARD DETAILS</h3>
      <div class="cardDetailForm" [ngClass]="{'ftpCardWidth' : !isWelcome}">
        <flash-messages></flash-messages>
        <div class="formControlMain">
          <div class="custome-deposit-amt">
            <label class="cardDetailLabel">Deposit Amount </label>
            <mat-form-field class="form-control m-15 form-input-amount">
              <span matPrefix>$</span>
              <input matInput type="custom" formControlName="custom_amt" (blur)="getAmount('other')"
                (keypress)="keyPress($event)">
            </mat-form-field>
            <div class="add-fund-buttons">
              <ng-container *ngIf="fundsData.dataList">
                <button type="button" mat-stroked-button
                  class="customChargeBtn" *ngFor="let item of fundsData.dataList" 
                  [ngClass]="{'checked_amt':((item.money == f.selected_package.value))}"
                   (click)="getAmount(item)" [disabled]="isCheckingPromo" >${{item.money |
                  number }}</button>
              </ng-container>
            </div>
            <div>
              <mat-error *ngIf="submitted  &&(this.f.selected_package.errors && this.f.selected_package.errors.required)  || (this.f.custom_amt.errors && this.f.custom_amt.errors.required)">
                Deposit amount is required.
            </mat-error>
            <mat-error *ngIf="submitted && this.f.custom_amt.errors && this.f.custom_amt.errors.pattern">
              Deposit amount is invalid.
            </mat-error>
            <mat-error *ngIf="submitted && this.f.custom_amt && this.f.custom_amt.errors && this.f.custom_amt.errors.minDepositError">
              Deposit must be greater than ${{minDeposit}}.
          </mat-error>
            <mat-error *ngIf="submitted && this.f.custom_amt && this.f.custom_amt.errors && this.f.custom_amt.errors.maxDepositError">
              Deposit must not exceed ${{maxDeposit}}.
          </mat-error>
            </div>
          </div>
        </div>
  
        <div class="formControlMain promo-code-container" *ngIf="!fundsData.hidePromo" [ngClass]="{'p-10':promo_code_validation && promo_code_validation.message && promo_code_validation.validate=='yes'}">
          <div class="promo-input">
            <div class="promovalue-input">
              <div class="w-90">
                <mat-form-field class="form-control promo-code ">
                  <input matInput type="text" formControlName="promo_code" (input)="promoCodeDisable()" maxlength="20">
                </mat-form-field>
              </div>
              <div class="promo-code-input-icon">
                <span class="promo-icon" *ngIf="promo_code_validation.icon"
                [ngStyle]="{'color': promo_code_validation.icon_color}"><i [class]="promo_code_validation.icon"></i></span>
              </div>
            </div>
            <button type="button"  color="" class="custom-btn check-pormoBtn"
            (click)="checkPromoCode('card')" [disabled]="isCheckingPromo || isCheckPromoDis">
            <span *ngIf="!isCheckingPromo">Apply</span>
            <span *ngIf="isCheckingPromo" class="circular-loader"></span>
          </button>
          </div>
          
          <mat-error
            *ngIf="promo_code_validation && promo_code_validation.message && promo_code_validation.validate!='yes'"
            style="position: relative;">{{
            promo_code_validation.message }}</mat-error>
         
        </div>
        <div class="pb-5 promoCodeMsg" *ngIf="promo_code_validation && promo_code_validation.message && promo_code_validation.validate=='yes'"
        style="position: relative;color:var(--green-dark)">+${{
        promo_code_validation.bonus_amount }} Bonus!</div>

        <div class="formControlMain">
          <div class="name-on-card">
            <mat-form-field class="form-control centered-placeholder " floatLabel='never'>
              <input matInput formControlName="name" placeholder="Name on card" maxlength="30">
            </mat-form-field>
            <mat-error *ngIf="submitted && !f.name.valid">
              Name on card is required or invalid.
            </mat-error>
          </div>
        </div>

        <div class="formControlMain">
          <div class="card-number">
            <mat-form-field class="form-control centered-placeholder " floatLabel='never'>
              <input matInput formControlName="card_number" placeholder="Card Number" ccNumber  maxlength="20">
            </mat-form-field>
            <mat-error *ngIf="submitted && !f.card_number.valid">
              Card Number is required or invalid.
            </mat-error>
          </div>
        </div>
        
        <div class="formControlMain exipiry-container">
          <div class="w-25">
            <mat-form-field class="form-control " floatLabel='never'>
              <input matInput formControlName="expiry" placeholder="MM/YY" type="tel" ccExp>
            </mat-form-field>
            <mat-error *ngIf="submitted && !f.expiry.valid">
              Expiry Date is required.
            </mat-error>
          </div>
          <div class="w-20">
            <mat-form-field class="form-control " floatLabel='never'>
              <input matInput formControlName="cvv" type="password" placeholder="CVV"  maxlength="4" >
            </mat-form-field>
            <mat-error *ngIf="submitted && f.cvv.errors && f.cvv.errors.required">
              CVV is required.
            </mat-error>
            <mat-error *ngIf="submitted && f.cvv.errors && (f.cvv.errors.minlength || f.cvv.errors.maxlength)">
              CVV must be min 3 digit and max 4 digit.
            </mat-error>
          </div>
          <div class="w-45">
            <mat-form-field class="form-control " floatLabel='never'>
              <input matInput formControlName="postal_code" placeholder="Zip/Postal Code"  maxlength="10">
            </mat-form-field>
            <mat-error *ngIf="submitted && f.postal_code.errors && f.postal_code.errors.required">
              Zip/Postal Code is required.
            </mat-error>
            <mat-error *ngIf="submitted && f.postal_code.errors && (f.postal_code.errors.minlength || f.postal_code.errors.maxlength)">
              Zip/Postal must be min 5 digit and max 10 digit.
            </mat-error>
          </div>
        </div>
        <div class="text-left">
          <button mat-raised-button color="primary" [disabled]="isDisable"  class="popupFundBtn w-100">Deposit</button>
          <div class="cardType">
            <div class="deposit-saved-cards"id="master">
              <img [src]="awsUploadUrl+'mastercard_logo.png'" alt="">
            </div>
            <div class="deposit-saved-cards" id="visa">
              <img [src]="awsUploadUrl+'visa_logo.png'" alt="">
              </div>
            <div class="deposit-saved-cards" id="express">
              <img [src]="awsUploadUrl+'express_logo.png'" alt="">
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>